import React from 'react';
import { NavLink} from'react-router-dom'
import styled from 'styled-components';

const TopCouponsHead = () => {
  return (
    <Wrapper>
      <div className="breadcrumb-container">
        <p className='d-flex'>
           <StyledNavLink to="/">Home / </StyledNavLink><span className='ms-1'>Top Coupons</span>
        </p>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  background-color: rgb(228, 224, 224);
  height: 40px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .breadcrumb-container {
    width: 100%;
    max-width: 1280px;
    padding: 0 90px;
  }

  p {
    margin: 0;
    // font-size: 18px;
    color: rgb(136, 134, 134);

    span {
      font-weight: 600;
      color: rgb(136, 134, 134);
    }
  }

  @media (max-width: 768px) {
    .breadcrumb-container {
      padding: 0 30px;
    }

    p {
      font-size: 16px;
    }
  }

  @media (max-width: 480px) {
    .breadcrumb-container {
      padding: 0 20px;
    }

    p {
      font-size: 15px;
    }
  }
`;

const StyledNavLink = styled(NavLink)`
  text-decoration: none;
  color: rgb(136, 134, 134);

`;

export default TopCouponsHead;
